import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { pop_back_item, push_back_item } from 'console/utils/back-button';
import { useBox } from '../../hooks/utils';
function BackAwareDialogImpl(props) {
    const { windowed, is_medium_ui, warning, error, ...rest } = props;
    const onCloseBox = useBox(props.onClose);
    const onBackClose = useCallback(() => {
        onCloseBox.current?.({}, 'escapeKeyDown');
    }, []);
    const onEnter = useCallback(() => push_back_item(onBackClose), [onBackClose]);
    const onExit = useCallback(() => pop_back_item(onBackClose), [onBackClose]);
    useEffect(() => {
        if (props.open) {
            onEnter();
        }
        return () => {
            if (props.open) {
                onExit();
            }
        };
    }, []);
    return _jsx(Dialog, { ...rest, children: props.children });
}
export const BackAwareDialog = memo(BackAwareDialogImpl);
